import React, { useState, useEffect } from 'react'
import {
  Input,
  Grid,
  Row,
  Col,
  Panel,
  RadioGroup,
  Radio,
  ControlLabel,
  Message,
  InputGroup,
  CheckboxGroup,
  Checkbox,
} from 'rsuite'
import { isValidators, requiredFiled, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import NumberFormat from 'react-number-format'
import classNames from 'classnames'

export default function WithdrawRequestWithProgressForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [isProblemEncountered, setIsProblemEncountered] = useState(false)
  const [isRiskEvaluationOfManagement, setIsRiskEvaluationOfManagement] = useState(false)
  const [isRiskEvaluationOfFinace, setIsRiskEvaluationOfFinace] = useState(false)
  const [coordinatorCommentType, setCoordinatorCommentType] = useState(1)
  const [isBuyingMaterialVal, setIsBuyingMaterialVal] = useState([])

  useEffect(() => {
    if (_schema.isProblemEncountered.value) {
      setIsProblemEncountered(true)
      setValue(schema.isProblemEncountered.name, true)
    }

    if (_schema.isRiskEvaluationOfManagement.value) {
      setIsRiskEvaluationOfManagement(true)
      setValue(schema.isRiskEvaluationOfManagement.name, true)
    }

    if (_schema.isRiskEvaluationOfFinace.value) {
      setIsRiskEvaluationOfFinace(true)
      setValue(schema.isRiskEvaluationOfFinace.name, true)
    }

    if (_schema.coordinatorCommentType.value) {
      setCoordinatorCommentType(_schema.coordinatorCommentType.value)
      setValue(schema.coordinatorCommentType.name, _schema.coordinatorCommentType.value)
    }

    if (_schema.isBuyingMaterial.value == 3) {
      setIsBuyingMaterialVal([1, 2])
      setValue(schema.isBuyingMaterial.name, [1, 2])
    } else {
      let newArr = []
      let _val = _schema?.isBuyingMaterial?.value || 0
      newArr.push(_val)
      setIsBuyingMaterialVal(newArr)
      setValue(schema.isBuyingMaterial.name, newArr)
    }
  }, [_schema])

  return (
    <Panel>
      <Grid fluid>
        {/* ปัญหาและอุปสรรค */}
        <div>
          <p>{schema.titleOfProblemEncountered.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <Controller
              key={schema.isProblemEncountered.name}
              name={schema.isProblemEncountered.name}
              control={control}
              defaultValue={schema.isProblemEncountered.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    //inline
                    onChange={(value) => {
                      props.onChange(value)
                      console.log(value)
                      setIsProblemEncountered(value)
                    }}
                  >
                    {schema.isProblemEncountered.options?.map((item) => {
                      return <Radio value={item.value}>{item.label}</Radio>
                    })}
                  </RadioGroup>
                )
              }}
            />

            {isProblemEncountered && (
              <Row style={{ marginTop: 10, marginLeft: 10 }}>
                <ErrorMessage error={errors[schema.problemDescription.name]} />

                <Row>
                  {requiredFiled(
                    schema.problemDescription.validators,
                    schema.problemDescription.label
                  )}
                  <Input
                    componentClass="textarea"
                    rows={3}
                    name={schema.problemDescription.name}
                    defaultValue={schema.problemDescription.value}
                    inputRef={register(isValidators(schema.problemDescription.validators))}
                    placeholder={schema.problemDescription.hint}
                  />
                </Row>
              </Row>
            )}
          </Row>
        </div>

        <br />

        {/* การประเมินความเสี่ยง */}
        <div>
          <p>{schema.titleOfRiskEvaluation.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            {requiredFiled(
              schema.isRiskEvaluationOfManagement.validators,
              schema.titleOfRiskEvaluationOfManagement.label
            )}
            <Controller
              key={schema.isRiskEvaluationOfManagement.name}
              name={schema.isRiskEvaluationOfManagement.name}
              control={control}
              defaultValue={schema.isRiskEvaluationOfManagement.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    //inline
                    onChange={(value) => {
                      props.onChange(value)
                      console.log(value)
                      setIsRiskEvaluationOfManagement(value)
                    }}
                  >
                    {schema.isRiskEvaluationOfManagement.options?.map((item) => {
                      return <Radio value={item.value}>{item.label}</Radio>
                    })}
                  </RadioGroup>
                )
              }}
            />

            {isRiskEvaluationOfManagement && (
              <Row style={{ marginTop: 10, marginLeft: 10 }}>
                <ErrorMessage error={errors[schema.riskEvaluationOfManagementDescription.name]} />

                <Row>
                  {requiredFiled(
                    schema.riskEvaluationOfManagementDescription.validators,
                    schema.riskEvaluationOfManagementDescription.label
                  )}
                  <Input
                    componentClass="textarea"
                    rows={3}
                    name={schema.riskEvaluationOfManagementDescription.name}
                    defaultValue={schema.riskEvaluationOfManagementDescription.value}
                    inputRef={register(
                      isValidators(schema.riskEvaluationOfManagementDescription.validators)
                    )}
                    placeholder={schema.riskEvaluationOfManagementDescription.hint}
                  />
                </Row>
              </Row>
            )}
          </Row>

          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            {requiredFiled(
              schema.isRiskEvaluationOfFinace.validators,
              schema.titleOfRiskEvaluationOfFinace.label
            )}
            <Controller
              key={schema.isRiskEvaluationOfFinace.name}
              name={schema.isRiskEvaluationOfFinace.name}
              control={control}
              defaultValue={schema.isRiskEvaluationOfFinace.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    //inline
                    onChange={(value) => {
                      props.onChange(value)
                      console.log(value)
                      setIsRiskEvaluationOfFinace(value)
                    }}
                  >
                    {schema.isRiskEvaluationOfFinace.options?.map((item) => {
                      return <Radio value={item.value}>{item.label}</Radio>
                    })}
                  </RadioGroup>
                )
              }}
            />

            {isRiskEvaluationOfFinace && (
              <Row style={{ marginTop: 10, marginLeft: 10 }}>
                <ErrorMessage error={errors[schema.riskEvaluationOfFinaceDescription.name]} />

                <Row>
                  {requiredFiled(
                    schema.riskEvaluationOfFinaceDescription.validators,
                    schema.riskEvaluationOfFinaceDescription.label
                  )}
                  <Input
                    componentClass="textarea"
                    rows={3}
                    name={schema.riskEvaluationOfFinaceDescription.name}
                    defaultValue={schema.riskEvaluationOfFinaceDescription.value}
                    inputRef={register(
                      isValidators(schema.riskEvaluationOfFinaceDescription.validators)
                    )}
                    placeholder={schema.riskEvaluationOfFinaceDescription.hint}
                  />
                </Row>
              </Row>
            )}
          </Row>
        </div>

        <br />

        {/* ประเมินความน่าสนใจ */}
        <div>
          <p>{schema.titleOfLevelOfInteresting.label}</p>
          <Message
            showIcon
            type="info"
            description={'ในการประชาสัมพันธ์ และเป็นแบบอย่างสำหรับโครงการอื่น'}
          />
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <Controller
              key={schema.levelOfInteresting.name}
              name={schema.levelOfInteresting.name}
              control={control}
              defaultValue={schema.levelOfInteresting.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    //inline
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.levelOfInteresting.options?.map((item) => {
                      return <Radio value={item.value}>{item.label}</Radio>
                    })}
                  </RadioGroup>
                )
              }}
            />
            <Row style={{ marginTop: 10, marginLeft: 10 }}>
              <ErrorMessage error={errors[schema.interestingDescription.name]} />
              <Row>
                {requiredFiled(
                  schema.interestingDescription.validators,
                  schema.interestingDescription.label
                )}
                <Input
                  componentClass="textarea"
                  rows={3}
                  name={schema.interestingDescription.name}
                  defaultValue={schema.interestingDescription.value}
                  inputRef={register(isValidators(schema.interestingDescription.validators))}
                  placeholder={schema.interestingDescription.hint}
                />
              </Row>
            </Row>
          </Row>
        </div>

        <br />

        {/* การใช้จ่ายเงิน */}
        <div>
          <p>{schema.titleOfBudgetRemain.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <Controller
              key={schema.isBudgetRemain.name}
              name={schema.isBudgetRemain.name}
              control={control}
              defaultValue={schema.isBudgetRemain.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    //inline
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.isBudgetRemain.options?.map((item) => {
                      return <Radio value={item.value}>{item.label}</Radio>
                    })}
                  </RadioGroup>
                )
              }}
            />
            <Row style={{ marginTop: 10, marginLeft: 10 }}>
              <ErrorMessage error={errors[schema.budgetRemainOrOver.name]} />
              {schema.budgetRemainOrOver.label}
              <span>
                {' '}
                {schema.budgetRemainOrOver.preLabel}
                <Controller
                  name={schema.budgetRemainOrOver.name}
                  control={control}
                  defaultValue={schema.budgetRemainOrOver.value || 0}
                  rules={isValidators(schema.budgetRemainOrOver.validators)}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className={classNames(
                          'rs-input',
                          errors[schema.budgetRemainOrOver.name] && 'is-error'
                        )}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                        }}
                        style={{ display: 'unset', width: 120, margin: '0px 15px' }}
                      />
                    )
                  }}
                />
                {schema.budgetRemainOrOver.postLabel}
              </span>
            </Row>
          </Row>
        </div>

        <br />

        {/* ความเห็นผู้สนับสนุนและติดตามโครงการ */}
        <div>
          <Row style={{ marginTop: 10, marginLeft: 5 }}>
            <ErrorMessage error={errors[schema.opinionOfCoordinator.name]} />
            <Row>
              {requiredFiled(
                schema.opinionOfCoordinator.validators,
                schema.opinionOfCoordinator.label
              )}
              <Input
                componentClass="textarea"
                rows={3}
                name={schema.opinionOfCoordinator.name}
                defaultValue={schema.opinionOfCoordinator.value}
                inputRef={register(isValidators(schema.opinionOfCoordinator.validators))}
                placeholder={schema.opinionOfCoordinator.hint}
              />
            </Row>
          </Row>
        </div>

        <br />

        {/* มีการซื้อครุภัณฑ์ */}
        <div>
          <p>{schema.titleOfBuyingMaterial.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <Controller
              key={schema.isBuyingMaterial.name}
              name={schema.isBuyingMaterial.name}
              control={control}
              defaultValue={schema.isBuyingMaterial.value}
              render={(props) => {
                return (
                  <CheckboxGroup
                    value={isBuyingMaterialVal}
                    onChange={(value, checked, e) => {
                      // console.log('value => ', value)

                      if (Array.isArray(value) && value.includes(0)) {
                        setIsBuyingMaterialVal([0])
                        setValue(schema.isBuyingMaterial.name, [0])
                        return false
                      }

                      if (value.length === 0) setValue(schema.isBuyingMaterial.name)
                      setIsBuyingMaterialVal(value)
                      setValue(schema.isBuyingMaterial.name, value)
                    }}
                  >
                    {schema?.isBuyingMaterial?.options?.map((item, index) => {
                      if (Array.isArray(isBuyingMaterialVal) && isBuyingMaterialVal.includes(0)) {
                        return (
                          <Checkbox
                            value={item.value}
                            key={index}
                            disabled={index == 0 ? false : true}
                          >
                            {item.label}
                          </Checkbox>
                        )
                      }

                      return (
                        <div style={{ display: 'flex' }}>
                          <Checkbox value={item.value} key={index} style={{ marginRight: 30 }}>
                            {item.label}
                          </Checkbox>
                          {Array.isArray(isBuyingMaterialVal) &&
                            isBuyingMaterialVal.includes(2) &&
                            index == 2 && (
                              <div style={{ marginTop: 11 }}>
                                <ErrorMessage error={errors[schema.projectCodeInputMore.name]} />
                                {requiredFiled(
                                  schema.projectCodeInputMore.validators,
                                  schema.projectCodeInputMore.label
                                )}
                                <Input
                                  name={schema.projectCodeInputMore.name}
                                  style={{ width: 650 }}
                                  defaultValue={schema.projectCodeInputMore.value}
                                  inputRef={register(
                                    isValidators(schema.projectCodeInputMore.validators)
                                  )}
                                  placeholder={schema.projectCodeInputMore.hint}
                                />
                              </div>
                            )}
                        </div>
                      )
                    })}
                  </CheckboxGroup>
                  // <RadioGroup
                  //   value={props.value}
                  //   //inline
                  //   onChange={(value) => {
                  //     props.onChange(value)
                  //   }}
                  // >
                  //   {schema.isBuyingMaterial.options?.map((item) => {
                  //     // console.log('props.value => ', props.value)
                  //     if (item.value == 2) {
                  //       return (
                  //         <>
                  //           <Radio value={item.value}>{item.label}</Radio>{' '}
                  //           {props.value == 2 && (
                  //             <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                  //               <ErrorMessage error={errors[schema.projectCodeInputMore.name]} />
                  //               {requiredFiled(
                  //                 schema.projectCodeInputMore.validators,
                  //                 schema.projectCodeInputMore.label
                  //               )}
                  //               <Input
                  //                 name={schema.projectCodeInputMore.name}
                  //                 // style={{ width: 450 }}
                  //                 defaultValue={schema.projectCodeInputMore.value}
                  //                 inputRef={register(
                  //                   isValidators(schema.projectCodeInputMore.validators)
                  //                 )}
                  //                 placeholder={schema.projectCodeInputMore.hint}
                  //               />
                  //             </div>
                  //           )}
                  //         </>
                  //       )
                  //     }

                  //     return <Radio value={item.value}>{item.label}</Radio>
                  //   })}
                  // </RadioGroup>
                )
              }}
            />
          </Row>
        </div>

        <br />

        {/* ประเมินความก้าวหน้าของโครงการ (อธิบาย) */}
        <div>
          <p>{schema.titleOfProgress.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <Controller
              key={schema.isProgress.name}
              name={schema.isProgress.name}
              control={control}
              defaultValue={schema.isProgress.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    //inline
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.isProgress.options?.map((item) => {
                      return <Radio value={item.value}>{item.label}</Radio>
                    })}
                  </RadioGroup>
                )
              }}
            />
            <Row style={{ marginTop: 10, marginLeft: 10 }}>
              <ErrorMessage error={errors[schema.progressDescription.name]} />
              <Row>
                {requiredFiled(
                  schema.progressDescription.validators,
                  schema.progressDescription.label
                )}
                <Input
                  componentClass="textarea"
                  rows={3}
                  name={schema.progressDescription.name}
                  defaultValue={schema.progressDescription.value}
                  inputRef={register(isValidators(schema.progressDescription.validators))}
                  placeholder={schema.progressDescription.hint}
                />
              </Row>
            </Row>
          </Row>
        </div>

        <br />

        {/* ความก้าวหน้าในการดำเนินงานตามแผน เมื่อเทียบกับแผนการดำเนินงานทั้งโครงการ */}
        <div>
          <Row style={{ marginTop: 10, marginLeft: 10 }}>
            <ErrorMessage error={errors[schema.percentOfProgress.name]} />
            <Row>
              {requiredFiled(
                schema.percentOfProgress.validators,
                schema.titleOfPercentOfProgress.label
              )}
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputGroup style={{ width: 300 }}>
                  {schema.percentOfProgress.preLabel && (
                    <InputGroup.Addon>
                      <p>{schema.percentOfProgress.preLabel}</p>
                    </InputGroup.Addon>
                  )}
                  <Controller
                    key={schema.percentOfProgress.name}
                    name={schema.percentOfProgress.name}
                    control={control}
                    rules={isValidators(schema.percentOfProgress.validators)}
                    defaultValue={schema.percentOfProgress.value}
                    render={(props) => {
                      return (
                        <NumberFormat
                          isAllowed={({ floatValue }) => !floatValue || floatValue <= 100}
                          className="rs-input"
                          placeholder={schema.percentOfProgress.hint}
                          thousandSeparator={true}
                          value={props.value}
                          onValueChange={(value) => {
                            setValue(schema.percentOfProgress.name, value.floatValue)
                            clearErrors(schema.percentOfProgress.name)
                          }}
                        />
                      )
                    }}
                  />
                  {schema.percentOfProgress.postLabel && (
                    <InputGroup.Addon>
                      <p>{schema.percentOfProgress.postLabel}</p>
                    </InputGroup.Addon>
                  )}
                </InputGroup>
              </Col>
            </Row>
          </Row>
        </div>

        <br />

        {/* ผลผลิตที่เกิดขึ้นจริง (สะสม) เทียบกับผลผลิตทั้งโครงการ */}
        <div>
          <Row style={{ marginTop: 10, marginLeft: 10 }}>
            <ErrorMessage error={errors[schema.percentOfActualOutcome.name]} />
            <Row>
              {requiredFiled(
                schema.percentOfActualOutcome.validators,
                schema.titleOfPercentOfActualOutcome.label
              )}
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputGroup style={{ width: 300 }}>
                  {schema.percentOfActualOutcome.preLabel && (
                    <InputGroup.Addon>
                      <p>{schema.percentOfActualOutcome.preLabel}</p>
                    </InputGroup.Addon>
                  )}
                  <Controller
                    key={schema.percentOfActualOutcome.name}
                    name={schema.percentOfActualOutcome.name}
                    control={control}
                    rules={isValidators(schema.percentOfActualOutcome.validators)}
                    defaultValue={schema.percentOfActualOutcome.value}
                    render={(props) => {
                      return (
                        <NumberFormat
                          isAllowed={({ floatValue }) => !floatValue || floatValue <= 100}
                          className="rs-input"
                          placeholder={schema.percentOfActualOutcome.hint}
                          thousandSeparator={true}
                          value={props.value}
                          onValueChange={(value) => {
                            setValue(schema.percentOfActualOutcome.name, value.floatValue)
                            clearErrors(schema.percentOfActualOutcome.name)
                          }}
                        />
                      )
                    }}
                  />
                  {schema.percentOfActualOutcome.postLabel && (
                    <InputGroup.Addon>
                      <p>{schema.percentOfActualOutcome.postLabel}</p>
                    </InputGroup.Addon>
                  )}
                </InputGroup>
              </Col>
            </Row>
          </Row>
        </div>

        <br />

        {/* ความเห็นของนักวิชาการสำนัก  */}
        <div>
          <p>{schema.titleOfCoordinatorComment.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <Controller
              key={schema.coordinatorCommentType.name}
              name={schema.coordinatorCommentType.name}
              control={control}
              defaultValue={schema.coordinatorCommentType.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    //inline
                    onChange={(value) => {
                      props.onChange(value)
                      console.log(value)
                      setCoordinatorCommentType(value)
                    }}
                  >
                    {schema.coordinatorCommentType.options?.map((item) => {
                      return <Radio value={item.value}>{item.label}</Radio>
                    })}
                  </RadioGroup>
                )
              }}
            />

            {coordinatorCommentType == 9 && (
              <Row style={{ marginTop: 10, marginLeft: 10 }}>
                <ErrorMessage error={errors[schema.otherComment.name]} />

                <Row>
                  {requiredFiled(schema.otherComment.validators, schema.otherComment.label)}
                  <Input
                    componentClass="textarea"
                    rows={3}
                    name={schema.otherComment.name}
                    defaultValue={schema.otherComment.value}
                    inputRef={register(isValidators(schema.otherComment.validators))}
                    placeholder={schema.otherComment.hint}
                  />
                </Row>
              </Row>
            )}
          </Row>
        </div>
      </Grid>
    </Panel>
  )
}
